// src/pages/Tools/nintendo-quest/components/NintendoQuestThemeOrchestrator.tsx

import React from 'react';
import { useNintendoQuestTheme } from '../contexts/NintendoQuestThemeContext';
import { NintendoQuestSummary } from '@/lib/nintendo-quest';

// Theme Components
import DefaultTheme from '../themes/DefaultTheme';
import LegoClassicTheme from '../themes/LegoClassicTheme';
import NinjagoTheme from '../themes/NinjagoTheme';

interface NintendoQuestThemeOrchestratorProps {
  data: NintendoQuestSummary;
}

const NintendoQuestThemeOrchestrator: React.FC<NintendoQuestThemeOrchestratorProps> = ({ data }) => {
  const { currentTheme } = useNintendoQuestTheme();

  // Route to appropriate theme component based on current theme
  const renderTheme = () => {
    switch (currentTheme) {
      case 'default':
        return <DefaultTheme data={data} />;
      
      case 'lego-classic':
        return <LegoClassicTheme data={data} />;
      
      case 'lego-ninjago':
        return <NinjagoTheme data={data} />;
      
      default:
        console.warn(`Unknown theme: ${currentTheme}, falling back to default`);
        return <DefaultTheme data={data} />;
    }
  };

  return (
    <div className={`nintendo-quest-theme-orchestrator theme-${currentTheme}`}>
      {renderTheme()}
    </div>
  );
};

export default NintendoQuestThemeOrchestrator;